import React from "react"
import Relay from "react-relay"
import Helmet from "react-helmet"
import { injectIntl } from "react-intl"
import sharedMessages from "../../messages/index"
import { getStyles } from "../../styles/dynamicStyles"
import { filterHTML } from "../../scripts/xss"

class CMSPage extends React.Component {
  _getContent = resource => {
    const content =
      resource && resource.files && resource.files.length > 0
        ? resource.files[0].contents
        : ""

    return { __html: content }
  }

  render() {
    // Bloody hell, We must be doing something wrong here
    const resource =
      this.props.viewer.resources.edges &&
      this.props.viewer.resources.edges.length > 0 &&
      this.props.viewer.resources.edges[0].node
    const haveResource = resource

    const title = haveResource
      ? resource.title
      : this.props.intl.formatMessage(sharedMessages.cantFindPage)
    const content = this._getContent(resource)

    return (
      <main id="main" role="main" tabIndex={0} data-article-style="page">
        <Helmet title={title} />
        <article className="c-article" role="article">
          <header
            className="c-article__header"
            style={getStyles("c-article__header")}
          >
            {haveResource && (
              <h1 className="c-article__title">{resource.title}</h1>
            )}
            {!haveResource && <h1 className="c-article__title">{title}</h1>}
          </header>

          <section
            className="c-article__content typography"
            dangerouslySetInnerHTML={content}
          />
        </article>
      </main>
    )
  }
}

export default Relay.createContainer(injectIntl(CMSPage), {
  initialVariables: {
    slug: null
  },

  fragments: {
    // TODO: replace hardcoded wordpress
    viewer: () => Relay.QL`
      fragment on Viewer {
        resources(first:1, source:"wordpress", source_id:$slug) {
          edges {
            node {
              id
              title,
              files {
                contents
              }
            }
          }
        }
      }
    	`
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/CMSPage.js